import { LayoutService, cssContentPadding } from './layout.service';
import { Injectable } from '@angular/core';
import { Device } from '@core/utilities/device';

const tooltip = document.createElement('tooltip');
const backdrop = document.createElement('backdrop');

LayoutService.change.subscribe(e => {
  if (e.type == 'scroll') {
    if (backdrop.parentElement) document.body.removeChild(backdrop);
    if (tooltip.parentElement) document.body.removeChild(tooltip);
  }
});

if (!Device.mobile) {
  tooltip.addEventListener('mouseout', () => document.body.removeChild(tooltip));
}
else {
  backdrop.addEventListener('click', (e) => {
    document.body.removeChild(tooltip);
    document.body.removeChild(backdrop);
    e.stopPropagation();
  });
}

@Injectable({
  providedIn: 'root'
})
export class TooltipService {

  public show(content: string, base: HTMLElement, css?: { font: string, lineHeight: string, textAlign: string, textTransform: string, letterSpacing: string, width: string, cursor: string }) {

    let rect = base.getBoundingClientRect() as DOMRect;

    if (!css) css = window.getComputedStyle(base);
    
    tooltip.innerText = content;

    //if (window.innerWidth - rect.x >= rect.x + rect.width) {
      tooltip.style.left = (rect.x - cssContentPadding) + "px";
      tooltip.style.removeProperty('right');
      tooltip.style.maxWidth = (window.innerWidth - rect.x) + "px";
    //}
    //else {
      //tooltip.style.right = (window.innerWidth - rect.x - rect.width - cssContentPadding) + "px";
      //tooltip.style.removeProperty('left');
      //tooltip.style.maxWidth = (rect.x + rect.width) + "px";
    //}

    //if (window.innerHeight - rect.y >= rect.y + rect.height) {
      tooltip.style.top = (rect.y - cssContentPadding / 2) + "px";
      tooltip.style.removeProperty('bottom');
    //}
    //else {
      //tooltip.style.bottom = (window.innerHeight - rect.y - rect.height - cssContentPadding / 2) + "px";
      //tooltip.style.removeProperty('top');
    //}

    tooltip.style.font = css.font;    
    tooltip.style.lineHeight = css.lineHeight;
    tooltip.style.textAlign = css.textAlign;
    tooltip.style.textTransform = css.textTransform;
    tooltip.style.letterSpacing = css.letterSpacing;
    tooltip.style.cursor = css.cursor;

    if (Device.mobile) {
      document.body.appendChild(backdrop);
    }

    tooltip.onclick = () => {

      if (Device.mobile) {
        document.body.removeChild(tooltip);
        document.body.removeChild(backdrop);
      }
      else {
        base.click();
      }      
    }

    document.body.append(tooltip);    
  }
}
